import { render, staticRenderFns } from "./AgencyContestFormPanel.vue?vue&type=template&id=d80872ca&scoped=true&"
import script from "./AgencyContestFormPanel.vue?vue&type=script&lang=js&"
export * from "./AgencyContestFormPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80872ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCardText,VCardTitle,VDivider,VFlex,VLayout,VSpacer})
